import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';

import Title from '../../components/Title/Title';

import useStyles from './Style';

const Premiacao = () => {
    const classes = useStyles();
    return (
        <>
            <Title id="anchor-07" className={classes.title}>
                7. PREMIAÇÃO
            </Title>

            <Typography className={classes.text} component={'div'} variant="body2">
                <span className={classes.item}>7.1</span> 
                Serão premiados Olimpíada de Professores da OBMEP Mirim os professores que obtiverem os melhores desempenhos, obedecendo e considerando exclusivamente 
                a ordenação decrescente das notas dos professores na prova e a quantidade estipulada de prêmios.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.2</span> A premiação dos professores será distribuída seguindo as categorias e as quantidades dispostas no quadro abaixo:
                <br /><br />

                <Grid 
                    container 
                    align='center' 
                    direction="row" 
                    justify="center"
                    alignItems="center"
                    className={classes.wrapper}
                >
                    <Grid item sm={6} lg={6}>
                        <TableContainer component="div">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="25%">Premiação</TableCell>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.backGray)} width="25%">Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#B68D4A', color: '#FFFFFF' }}>Medalha de OURO</TableCell>
                                        <TableCell align="center" className={classes.bolder}>25</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A3A2A0', color: '#FFFFFF' }}>Medalha de PRATA</TableCell>
                                        <TableCell align="center" className={classes.bolder}>50</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={classes.bolder} style={{ backgroundColor: '#A46628', color: '#FFFFFF' }}>Medalha de BRONZE</TableCell>
                                        <TableCell align="center" className={classes.bolder}>100</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: 1 }}>
                                        <TableCell align="center" className={clsx(classes.bolder, classes.lightGray)}>Menção Honrosa</TableCell>
                                        <TableCell align="center" className={classes.bolder}>500</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.3</span>
                Em caso de empate de professores, serão aplicados os critérios de desempate obedecendo a seguinte ordem:
                <br />

                <ul className={classes.list}>
                    <li><span className={classes.item}>1º critério de desempate:</span> Maior número de acertos em questões previamente determinadas pelo Comitê de Provas responsável pela elaboração das questões das provas, das soluções e das pautas de correção;</li>
                    <li><span className={classes.item}>2º critério de desempate:</span> Prevalecendo o empate após a aplicação do 1º critério de desempate, o premiado será definido aleatoriamente pelo sistema.</li>
                </ul>
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.4</span>
                Todos os professores premiados com <span className={classes.bolder}>Menção Honrosa</span> receberão Certificado Digital de Menção Honrosa.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.5</span>
                Todos os professores <span className={classes.bolder}>medalhistas</span> receberão medalha no nível alcançado (ouro, prata ou bronze) e certificado digital de premiação correspondente à medalha alcançada. Além disso, serão 
                convidados a participar do Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I que será ministrado na modalidade virtual (à distância).
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.6</span> 
                As datas e a duração do Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I serão determinadas pelo <span className={classes.bolder}>IMPA</span> independentemente da 
                disponibilidade de data e de participação do medalhista.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.7</span>
                O Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I é uma premiação destinada exclusivamente aos medalhistas da Olimpíada de Professores da OBMEP Mirim, sendo, portanto, pessoal e intransferível, e obedecerá às regras 
                determinadas pelo <span className={classes.bolder}>IMPA</span>. O medalhista que, por ventura, declinar do convite para participar do curso não terá o direito de reivindicar qualquer premiação compensatória.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.8</span>
                Além das premiações elencadas no item 7.5, cada professor premiado com <span className={classes.bolder}>medalha de prata</span> receberá um kit pedagógico.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.9</span>
                Aos <span className={classes.bolder}>medalhistas de ouro</span>, será oferecida a possibilidade de participar presencialmente de parte das aulas do Curso Digital de Formação, nas instalações do <span className={classes.bolder}>IMPA</span>, na cidade do Rio de Janeiro, 
                onde o curso será gravado e transmitido. O período de aulas presenciais, oferecidas exclusivamente aos <span className={classes.bolder}>medalhistas de ouro</span>, será definido pelo <span className={classes.bolder}>IMPA</span> e as despesas correspondentes a passagens, 
                deslocamento, traslados, hospedagem e alimentação para o período, serão custeadas pelo <span className={classes.bolder}>IMPA</span>.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.10</span>
                O convite para participação presencial de parte das aulas do Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I inclui:

                <ul className={classes.list}>
                    <li>
                        <span className={classes.item}>{"a)"}</span> Passagens aéreas ou rodoviárias de ida de volta para o local das aulas, que serão ministradas no <span className={classes.bolder}>IMPA</span>, na cidade 
                        do Rio de Janeiro. A definição do tipo de transporte, número de dias, data e horário de chegada e retorno para a cidade de origem cabe exclusivamente ao <span className={classes.bolder}>IMPA</span>, não 
                        sendo permitido ao medalhista de ouro escolher o tipo de transporte que será utilizado, nem a data;
                    </li>
                    <li><span className={classes.item}>{"b)"}</span> Transfer do aeroporto ou da rodoviária para o local do evento e do local do evento para o aeroporto ou rodoviária ao final do período.</li>
                    <li><span className={classes.item}>{"c)"}</span> Hospedagem em apartamento triplo para todos os dias de participação presencial das aulas;</li>
                    <li><span className={classes.item}>{"d)"}</span> Alimentação (café, almoço e jantar) durante todos o período das primeiras aulas.</li>
                    <li>
                        <span className={classes.item}>{"e)"}</span> As despesas de deslocamento até o aeroporto ou rodoviária de origem com destino ao local das primeiras aulas, bem como as 
                        despesas de deslocamento do aeroporto ou rodoviária de origem ao retornar, não serão custeadas pelo <span className={classes.bolder}>IMPA</span> e ficarão a cargo do medalhista de ouro.
                    </li>
                </ul>
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.11</span>
                Todos os benefícios listados no item 7.10 serão concedidos exclusivamente ao medalhista de ouro, sendo vedada a participação de acompanhantes bem como a transferência de qualquer desses benefícios a terceiros.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.12</span>
                O <span className={classes.bolder}>medalhista de ouro</span> que, por ventura, declinar do convite para participação presencial de parte das aulas do Curso Digital de Formação em Matemática para Professores 
                do Ensino Fundamental I, não terá o direito de reivindicar qualquer premiação compensatória.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.13</span>
                O <span className={classes.bolder}>medalhista de ouro</span>, ao aceitar o convite para participar presencialmente de parte das aulas do Curso Digital de Formação em Matemática para Professores do Ensino 
                Fundamental I deverá concordar e cumprir estritamente todas as regras determinadas pela organização do evento, tais quais:

                <ul className={classes.list}>
                    <li>
                        <span className={classes.item}>{"a)"}</span> Ler, assinar e enviar para o <span className={classes.bolder}>IMPA</span>, dentro do prazo estipulado toda a documentação solicitada, bem como a confirmação de participação e o termo de 
                        responsabilidade e de cumprimento integral das regras do evento. <span className={classes.bolder}>Medalhistas de ouro</span> que não respeitarem o prazo para confirmação de participação, não poderão participar presencialmente do curso.
                    </li>
                    <li>
                        <span className={classes.item}>{"b)"}</span> Toda e qualquer despesa extra – frigobar, toalhas extras, room service, dentre outras, deverá ser assumida e quitada pelo professor premiado. O
                        <span className={classes.bolder}>IMPA</span> não se responsabilizará, sob qualquer hipótese, por consumo ou despesas adicionais geradas pelo <span className={classes.bolder}>medalhista de ouro</span>.
                    </li>
                </ul>
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.14</span>
                As medalhas de ouro da Olimpíada de Professores da OBMEP Mirim serão entregues em Cerimônia Nacional de Premiação que será organizada pelo <span className={classes.bolder}>IMPA</span> em algum momento dos dois anos subsequentes à 
                realização desta edição da Olimpíada, salvo justo motivo ou força maior. O local e a data da Cerimônia Nacional de Premiação dos <span className={classes.bolder}>medalhistas de ouro</span> serão definidos 
                pelo <span className={classes.bolder}>IMPA</span> e divulgados oportunamente.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.15</span>
                Após a conclusão do Curso Digital de Formação em Matemática para Professores do Ensino Fundamental I, os <span className={classes.bolder}>medalhistas de ouro</span> poderão submeter projeto 
                que comprove a aplicação do conteúdo desse cursos em sala de aula para alunos do Ensino Fundamental I.
            </Typography>

            <Typography className={classes.text} variant="body2">
                <span className={classes.item}>7.16</span>
                Todos os projetos propostos por medalhistas serão analisados e os professores responsáveis pelos projetos que sejam selecionados pelo <span className={classes.bolder}>IMPA</span> receberão bolsa de 
                R$ 700,00 (setecentos reais) por 4 (quatro) meses consecutivos. O prazo, os critérios para submissão do projeto e as normas para o recebimento da bolsa serão divulgados oportunamente 
                pelo <span className={classes.bolder}>IMPA</span>.
            </Typography>
        </>
    )
}

export default Premiacao;
